
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import { useRouter } from '@/routing/router'
import ASimpleTooltip from '@/components/Ui/ASimpleTooltip.vue'
import AButton from '@/components/Forms/AButton.vue'
import useConfiguration from '@/composables/configuration/configuration'
import { OfferLinkPosition } from '@/routing/refManager'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_EDIT,
  emits: ['tooltip-close'],
  components: { AButton, ASimpleTooltip },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      checked: false,
      POST_TOOLTIP_EDIT: OfferLinkPosition.POST_TOOLTIP_EDIT,
    }
  },
  setup() {
    return {
      ...useRouter(),
      ...useConfiguration(),
    }
  },
})
